import React from 'react';
import PropTypes from 'prop-types';

import TextField from '@material-ui/core/TextField';
import { MenuItem } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';

const RenderSelectField = ({
  meta: { touched, error },
  input,
  autocomplete,
  ...props
}) => (
  <TextField
    error={touched && error}
    autoComplete={autocomplete}
    {...input}
    {...props}
    select
  >
    {props.options?.map(({ label, value }) => (
      <MenuItem key={value} value={value}>
        <FormattedMessage id={label} defaultMessage={label} />
      </MenuItem>
    ))}
  </TextField>
);

RenderSelectField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.object,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  autocomplete: PropTypes.string,
  props: PropTypes.object,
  options: PropTypes.array,
};

RenderSelectField.defaultProps = {
  disabled: false,
  placeholder: '',
  label: '',
  type: 'text',
  autocomplete: null,
  meta: {},
  props: {},
  options: [],
};

export default RenderSelectField;
